const CALL_PARAMS_INLINE_MAX_LENGTH = 48
const CALL_PARAMS_MULTILINE_MIN_COUNT = 4
const INDENT = '  '

const CALL_PATTERN = /([A-Za-z_$][\w$.]*)\(([^()\n]*)\)/g
const SIMPLE_ARGUMENT_PATTERN = /^[A-Za-z_$][\w$.]*$/

function shouldFormatCall(args: string[]): boolean {
  if (args.length < CALL_PARAMS_MULTILINE_MIN_COUNT) {
    return false
  }

  return args.every((arg) => SIMPLE_ARGUMENT_PATTERN.test(arg))
}

function formatCall(match: string, callee: string, rawArgs: string, lineIndent: string): string {
  const args = rawArgs
    .split(',')
    .map((arg) => arg.trim())
    .filter(Boolean)

  if (args.length === 0) {
    return match
  }

  if (!shouldFormatCall(args) && rawArgs.length <= CALL_PARAMS_INLINE_MAX_LENGTH) {
    return match
  }

  if (!args.every((arg) => SIMPLE_ARGUMENT_PATTERN.test(arg))) {
    return match
  }

  const nestedIndent = `${lineIndent}${INDENT}`

  return `${callee}(\n${nestedIndent}${args.join(`,\n${nestedIndent}`)}\n${lineIndent})`
}

export function formatCodeSnippetCalls(code: string): string {
  return code
    .split('\n')
    .map((line) => {
      const lineIndent = line.match(/^\s*/)?.[0] ?? ''
      return line.replaceAll(CALL_PATTERN, (match, callee: string, rawArgs: string) =>
        formatCall(match, callee, rawArgs, lineIndent)
      )
    })
    .join('\n')
}
